import ResourceTyped from 'Resources/ResourceTyped';

import type { ExternalIntegrationGlobalSettings } from 'App/components/hooks/integrations/externalIntegrationTypes';

class ExternalIntegrationSettingsResource extends ResourceTyped<ExternalIntegrationGlobalSettings> {
	constructor() {
		super('master/externalIntegrationSettings', undefined, {
			notificationTitle: 'default.settings'
		});
	}
}

const resource = new ExternalIntegrationSettingsResource();

export default resource;
